import { render, staticRenderFns } from "./TableProductos.vue?vue&type=template&id=3a08176d&"
import script from "./TableProductos.vue?vue&type=script&lang=js&"
export * from "./TableProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports